import React from "react";
import { useTable, useFilters, useSortBy } from "react-table";

 function Table({ columns, data }) {
  //const [filterInput, setFilterInput] = useState("");
   

  //console.log("Table Data:", columns, data)
  
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
   // setFilter
  } = useTable(
    {
      columns,
      data
    },
    useFilters,
    useSortBy
  );

  // const handleFilterChange = e => {
  //   const value = e.target.value || undefined;
  //   setFilter("product.typeIndicator", value);
  //   setFilterInput(value);
  // };

  // Render the UI for your table
  return (
    <>
      {/* <input
        value={filterInput}
        onChange={handleFilterChange}
        placeholder={"Search"}
      /> */}
      <table className="reloc-table" {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr  className="reloc-table-tr" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th 
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className= {
                      column.isSorted
                      ? column.isSortedDesc
                        ? "sort-desc"
                        : "sort-asc"
                      : ""
                  }
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
export default  Table